<template>
  <div>
    <v-btn ref="btn" @click="onCancel" :disabled="!cancelEnabled" v-if="cancelVisible" fixed bottom
           class="mb-8 ml-2">
      {{ cancelTextReactive }}
    </v-btn>
    <v-btn @click="onConfirm" :disabled="!confirmEnabled" v-if="confirmVisible" fixed bottom right
           class="mb-8 mr-1" :style="rightButtonCss" color="success" :dark="confirmEnabled">
      {{ confirmTextReactive }}
    </v-btn>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';

@Component
export default class DynameatConfirmationButtons extends Vue {
  @Prop({ Boolean, default: true }) confirmEnabled;

  @Prop({ Boolean, default: true }) cancelEnabled;

  @Prop({ Boolean, default: true }) confirmVisible;

  @Prop({ Boolean, default: true }) cancelVisible;

  @Prop({ type: String, default() { return null; } }) cancelText;

  @Prop({ type: String, default() { return null; } }) confirmText;

  rightButtonCss = {}

  onCancel() {
    this.$emit('cancel');
  }

  onConfirm() {
    this.$emit('confirm');
  }

  get confirmTextReactive() {
    return this.confirmText ? this.confirmText : this.$t('confirm');
  }

  get cancelTextReactive() {
    return this.cancelText ? this.cancelText : this.$t('cancel');
  }

  created() {
    window.addEventListener('resize', this.positionAcceptButton);
  }

  mounted() {
    this.positionAcceptButton();
  }

  destroyed() {
    window.removeEventListener('resize', this.positionAcceptButton);
  }

  positionAcceptButton() {
    const element = this.$parent.$vnode?.elm;
    if (element) {
      const marginRightText = window.getComputedStyle(element).marginRight;
      const [margin, size] = marginRightText.match(/[\d\.]+|\D+/g);
      const marginRight = `${parseFloat(margin) + 3}${size} !important`;
      this.rightButtonCss = { marginRight };
    }
  }
}
</script>
